import React from 'react';
import { IProps as ICTABlockProps } from './CTABlock.interface';
import { CTABlock } from './CTABlock.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';
import * as translation from '@/utils/TranslationComponent/translation.utilities';

export interface ICTABlockInputProps {
  heading?: string;
  description?: string;
  buttons?: unknown[];
  background?: string;
  [key: string]: unknown;
}

const mapInputToProps = (input: ICTABlockInputProps): ICTABlockProps => {
  const { heading, description, buttons, background, ...rest } = input;
  return {
    title: heading || undefined,
    description: description || undefined,
    buttons:
      buttons && Array.isArray(buttons) && buttons.length > 0
        ? buttons.map((button: any) => translation.mapAnchorProps(button))
        : undefined,
    backgroundColor: background || 'white',
    ...rest,
  };
};

const CTABlockTranslation: React.FC<ICTABlockInputProps> = (inputProps) => (
  <TranslationComponent inputProps={inputProps} TargetComponent={CTABlock} mapProps={mapInputToProps} />
);

export default CTABlockTranslation;
